import type { JSX } from 'react'
import type { IProgressBarProps } from '../ProgressBar'

import { COLOR } from 'vars/color'
import { ProgressBar } from '../ProgressBar'
import { Corners } from '../ProgressBar.h'

export interface IProgressBarAccentTemplate extends IProgressBarProps {}

export const ProgressBarAccentTemplate = ({
  progress,
  color = COLOR.ACCENT_SECONDARY,
  corners = Corners.CORNERS_0,
  ...rest
}: IProgressBarAccentTemplate): JSX.Element => {
  return (
    <ProgressBar
      color={color}
      corners={corners}
      progress={progress}
      {...rest}
    />
  )
}
